// extracted by mini-css-extract-plugin
export default {"wrapper":"jq-z","response":"kq-z","error":"lq-z","disabled":"mq-z","buttons":"nq-z","feedbackQuestionSection":"oq-z","yesNoWrapper":"pq-z"};